import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@lib/modal";

export default function BetSlipConfirmationModal(props: {
	headerText?: string;
	bodyText?: string;
	onReject: () => void;
	onAccept: () => void;
}) {
	const { t } = useTranslation();

	return (
		<Modal>
			<div className="popup" data-at="at-BetSlipConfirmationModal">
				<div className="popup__card">
					<div className="popup__header">
						{props.headerText && props.headerText !== ""
							? t<string>(props.headerText)
							: null}
					</div>
					<div className="popup__body">
						{props.bodyText && props.bodyText !== ""
							? t<string>(props.bodyText)
							: null}
					</div>
					<div className="popup__footer">
						<button
							className="popup__btn popup__btn--secondary btn btn--med btn--primary--inverted"
							onClick={props.onReject}
						>
							{t<string>("BET_SLIP.NO")}
						</button>
						<button
							className="popup__btn popup__btn--primary btn btn--med btn--accent"
							onClick={props.onAccept}
						>
							{t<string>("BET_SLIP.YES")}
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
}
